const RESET_CTX_KEY = 'pwdReset:ctx';
const RESET_CTX_TTL_MS = 10 * 60 * 1000; // matches the server-side code and token TTLs

export const RESET_RESEND_COUNT_KEY = 'resendCount:reset:email';

interface IResetCtx {
  identifier: string;
  resetToken?: string;
  ts: number;
}

export function saveResetCtx(identifier: string) {
  const payload: IResetCtx = { identifier, ts: Date.now() };
  sessionStorage.setItem(RESET_CTX_KEY, JSON.stringify(payload));
  sessionStorage.removeItem(RESET_RESEND_COUNT_KEY);
}

export function saveResetToken(resetToken: string) {
  const ctx = readCtx();
  if (!ctx) {
    return;
  }

  const payload: IResetCtx = { ...ctx, resetToken, ts: Date.now() };
  sessionStorage.setItem(RESET_CTX_KEY, JSON.stringify(payload));
}

export function getResetCtx(): string | null {
  return readCtx()?.identifier ?? null;
}

export function getResetToken(): string | null {
  return readCtx()?.resetToken ?? null;
}

export function clearResetCtx() {
  sessionStorage.removeItem(RESET_CTX_KEY);
  sessionStorage.removeItem(RESET_RESEND_COUNT_KEY);
}

function readCtx(): IResetCtx | null {
  try {
    const raw = sessionStorage.getItem(RESET_CTX_KEY);
    if (!raw) {
      return null;
    }

    const ctx = JSON.parse(raw) as IResetCtx;
    if (!ctx.identifier || !ctx.ts || Date.now() - ctx.ts > RESET_CTX_TTL_MS) {
      sessionStorage.removeItem(RESET_CTX_KEY);
      return null;
    }

    return ctx;
  } catch {
    sessionStorage.removeItem(RESET_CTX_KEY);
    return null;
  }
}
